<template>
  <v-flex class="affix-target">
    <v-tabs
      v-model="tabModel"
      ref="stepTabs"
      :class="[isTabsFixed && isMdScreen ? 'fixed-tabs' : 'static-tabs']"
      class="module-tabs"
      slider-color="black"
      align-with-title
      show-arrows
    >
      <v-tab
        v-for="(step, index) in orderedSteps"
        :key="'tab-' + step.id"
        :step="step"
        @click="tabActivated(index)"
        class="font-weight-bold subheading text-none d-inline-flex align-center"
        :class="{ 'long-subheading': step.name.length > 25 }"
        :ref="'tab-' + step.id"
        :href="`#step-${index}`"
      >
        <v-flex>
          <v-icon small color="primary" class="mr-2 tab-icon">{{
            step.icon
          }}</v-icon>
          <span>{{ index + 1 }}. {{ step.name }}</span>
        </v-flex>
      </v-tab>
      <v-tab-item
        :value="`step-${index}`"
        v-for="(step, index) in orderedSteps"
        :key="'tab-item-' + step.id"
        :step="step"
      >
        <StepItem
          :module="module"
          :step="step"
          :stepIndex="index"
          :formModel="formModel"
          v-if="tabVisible[index]"
          :dropzones="dropzones"
          :tabModel="tabModel"
          :key="'step-item-key-' + step.id"
          :isLastStep="!orderedSteps[index + 1]"
        >
          <template v-if="orderedSteps[index + 1]">
            <v-btn
              @click="advanceTabTo(index + 1)"
              color="primary"
              class="ml-3"
            >
              Next: {{ orderedSteps[index + 1].name }}
            </v-btn>
          </template>
        </StepItem>
      </v-tab-item>
    </v-tabs>
  </v-flex>
</template>

<style lang="scss">
@import "src/styles/variables.scss";
.module-tabs {
  .vue-affix {
    width: 250px;
  }
  .v-tabs__wrapper,
  .v-tabs__container {
    height: 100%;
    align-items: center;

    .v-tabs__slider {
      height: 4px;
    }
  }
  .v-tabs__bar {
    height: 64px;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.12),
      0 -2px 2px -1px rgba(0, 0, 0, 0.12);
  }
  &.fixed-tabs {
    padding-top: 115px;
    > .v-tabs__bar {
      position: fixed;
      top: 64px;
      z-index: 20;
      width: 100%;
    }
  }
  &.v-tabs.static-tabs > .v-window {
    padding-top: 52px;
  }
  a.v-tabs__item {
    .tab-icon {
      vertical-align: middle !important;
    }
    &.v-tabs__item--active * {
      color: #000 !important;
    }
  }
}
</style>

<script>
import StepItem from "./StepItem";
import { orderBy } from "lodash";

export default {
  data() {
    return {
      tabModel: "step-0",
      formModel: {},
      isTabsFixed: false,
      tabVisible: [true],
      dropzones: []
    };
  },
  props: {
    module: Object
  },
  components: {
    StepItem
  },
  computed: {
    orderedSteps() {
      return orderBy(this.module.steps, "order");
    },
    isMdScreen() {
      return this.$vuetify.breakpoint.mdAndUp;
    }
  },
  watch: {
    module: function () {
      this.$nextTick(() => {
        this.advanceTabTo(0, true);
        this.formModel = {};
      });
    },
    tabModel: function (step) {
      if (typeof this.formModel[step] === "undefined") {
        // nest evaluation forms under the current tab's `step-<id>`
        this.formModel[step] = {};
      }
    }
  },
  methods: {
    checkTabsOffset() {
      return this.$refs.stepTabs.$el.offsetTop <= window.pageYOffset;
    },
    polyfillRAF() {
      window.requestAnimationFrame =
        window.requestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (f) {
          return setTimeout(f, 1000 / 60);
        }; // simulate calling code 60
    },
    onScroll(e) {
      window.requestAnimationFrame(() => {
        this.isTabsFixed = this.checkTabsOffset();
      });
    },
    tabActivated(tabIndex) {
      const count = this.tabVisible.length - 1;
      if (tabIndex > count) {
        for (let i = 0; i < tabIndex - count; i++) {
          this.tabVisible.push(false);
        }
      }
      // wait till tab is activated
      this.$nextTick(() => {
        this.$set(this.tabVisible, tabIndex, true);
        // scroll step item back up on new tab transition
        window.scrollTo({
          top: this.$refs.stepTabs.$el.offsetTop,
          behavior: "auto" // immediate
        });
      });
    },
    advanceTabTo(nextIndex, doNotScroll) {
      this.tabModel = `step-${nextIndex}`;
      if (!doNotScroll) {
        this.tabActivated(nextIndex);
      }
    }
  },
  created() {
    this.polyfillRAF();
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  activated() {
    // remove fixed tabs after reactivating a route
    this.isTabsFixed = false;
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  }
};
</script>
